import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { HeaderMain } from './HeaderWrapperList.style';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { useCommon } from 'src/domains/common/Common';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface HeaderWrapperListPropsType {
    className?: string;
    children: React.ReactNode;
}

export const HeaderWrapperList = observer('HeaderWrapperList', (props: HeaderWrapperListPropsType) => {
    const { className, children } = props;
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const config = ConfigComponents.get(common).config;
    const { closureModeWithLogin, closureModeSignupOnly } = config;
    const { basicData } = BasicDataModel.get(common);
    const customerBasicData = basicData.get();

    const streamingState = StreamingState.get(common);

    const streamBoxHeight = streamingState.streamBoxHeight;
    const streamFloating = streamingState.isStreamFloating;

    const { bannersBoxState } = appLayoutsState;
    const bannersHeight = bannersBoxState.boxHeight;

    const isTartanClub = customerBasicData.type === 'ready' ? customerBasicData.value?.tartanClub ?? false : false;
    const isClosureMode = closureModeWithLogin || closureModeSignupOnly;

    return (
        <HeaderMain
            bannersHeight={bannersHeight}
            className={className}
            isFloating={streamFloating}
            isTartanClub={isTartanClub}
            isClosureMode={isClosureMode}
            streamBoxHeight={streamBoxHeight}
        >
            {children}
        </HeaderMain>
    );
});
